/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class JwtApiBase {
  AccessToken: Promise<string> | undefined

  protected readonly transformOptions = async (options: RequestInit): Promise<RequestInit> => {
    const token = await this.AccessToken

    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    }

    return options
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  public readonly setAccessToken = (token: Promise<string>) => {
    this.AccessToken = token
  }
}

export interface ISessionManagementClientV1 {

    /**
     * Checks if service is alive.
     * @return service is alive.
     */
    ping(): Promise<void>;

    /**
     * Get content metadata names for a company.
     * @return Returns a list of content metadata names for a company.
     */
    getContentMetadataNames(companyId: string): Promise<ContentMetadataName[]>;

    /**
     * Report user-level metrics for a company.
     * @return Returns a list of user-level metric results for the given filters.
     */
    getUserLevelMetrics(companyId: string, body: UserLevelMetricFilter): Promise<UserSessionMetricResult>;

    /**
     * Report hours in VR metrics for a company.
     * @return Returns a list of metric results for the given filters.
     */
    getHoursInVrMetrics(companyId: string, body: MetricFilter): Promise<MetricResult>;

    /**
     * Report unique active user metrics for a company.
     * @return Returns a list of metric results for the given filters.
     */
    getUniqueActiveUserMetrics(companyId: string, body: MetricFilter): Promise<MetricResult>;

    /**
     * Report all aggregate metrics for a company.
     * @return Returns a list of all aggregate metric results for the given filters.
     */
    getAllAggregateMetrics(companyId: string, body: MetricFilter): Promise<AllAggregateMetricResult>;

    /**
     * Report user session metrics for a company.
     * @return Returns a list of metric results for the given filters.
     */
    getUserSessionMetrics(companyId: string, body: MetricFilter): Promise<MetricResult>;

    /**
     * Report cumulative metrics for a company.
     * @return Returns the cumulative metric results for the given filters.
     */
    getCumulativeMetrics(companyId: string, body: MetricFilter): Promise<CumulativeMetricsResult>;

    /**
     * Report Experience-based metrics for a company.
     * @return Returns a list of metric results for the given filters.
     */
    getExperienceDataMetrics(companyId: string, body: MetricFilter): Promise<ExperienceMetricResult>;

    /**
     * Report Country-based metrics for a company.
     * @return Returns a list of metric results for the given filters.
     */
    getCountryDataMetrics(companyId: string, body: MetricFilter): Promise<CountryMetricResult>;

    /**
     * Report hours in VR metrics for a company's licensed experience.
     * @return Returns a list of metric results for the given filters.
     */
    getHoursInVrExternalMetrics(companyId: string, body: ExternalMetricFilter): Promise<MetricResult>;

    /**
     * Report unique active user metrics for a company's licensed experience.
     * @return Returns a list of metric results for the given filters.
     */
    getUniqueActiveUserExternalMetrics(companyId: string, body: ExternalMetricFilter): Promise<MetricResult>;

    /**
     * Report user session metrics for a company's licensed experience.
     * @return Returns a list of metric results for the given filters.
     */
    getUserSessionExternalMetrics(companyId: string, body: ExternalMetricFilter): Promise<MetricResult>;

    /**
     * Report all aggregate metrics for a company's licensed experience.
     * @return Returns a list of all aggregate metric results for the given filters.
     */
    getAllAggregateExternalMetrics(companyId: string, body: ExternalMetricFilter): Promise<AllAggregateMetricResult>;

    /**
     * Report cumulative metrics for a company's licensed experience.
     * @return Returns the cumulative metric results for the given filters.
     */
    getCumulativeExternalMetrics(companyId: string, body: ExternalMetricFilter): Promise<CumulativeMetricsResult>;

    /**
     * Get all pending multiplayer session invitations for active sessions for current user.
     * @return returns a list of pending multiplayer session invitations for active sessions for current user
     */
    getCurrentUserPendingMultiplayerSessionInvitations(): Promise<MultiplayerSessionInvitation[]>;

    /**
     * Get all multiplayer sessions for current user.
     * @param states (optional) 
     * @return returns a multiplayer session for a given multiplayer session Id
     */
    getCurrentUserMultiplayerSessions(states: UserMultiplayerSessionState[] | undefined): Promise<MultiplayerSession[]>;

    /**
     * Create current user device session.
     * @param clientIpAddress (optional) 
     * @return Device Session successfully created and can be found in the body of the response.
     */
    createCurrentUserDeviceSession(clientIpAddress: string | undefined, body: DeviceSessionWithoutId): Promise<DeviceSession>;

    /**
     * Returns Current User Device Sessions
     * @return Current User Device Sessions
     */
    getCurrentUserDeviceSessions(): Promise<DeviceSession[]>;

    /**
     * Delete the device sessions. If no device session id is provided, all device sessions will be deleted; otherwise, only those specified will be deleted.
     * @param deviceSessionIds (optional) deviceSessionId(s) to be deleted.
     * @param clientIpAddress (optional) 
     * @return Current User Device Sessions have been deleted.
     */
    deleteCurrentUserDeviceSessions(deviceSessionIds: string[] | undefined, clientIpAddress: string | undefined): Promise<void>;

    /**
     * Update a Current User Device Session.
     * @param clientIpAddress (optional) 
     * @return Given Current User Device Session has been updated
     */
    updateCurrentUserDeviceSession(deviceSessionId: string, clientIpAddress: string | undefined, body: DeviceSessionToUpdate): Promise<void>;

    /**
     * Delete a Current User Device Session
     * @param clientIpAddress (optional) 
     * @return Given Current User Device Session has been deleted.
     */
    deleteCurrentUserDeviceSession(deviceSessionId: string, clientIpAddress: string | undefined): Promise<void>;

    /**
     * Create a new multiplayer session
     * @return Multiplayer session successfully created and can be found in the body of the response.
     */
    createMultiplayerSession(body: MultiplayerSessionWithoutId): Promise<MultiplayerSession>;

    /**
     * Get all accessible multiplayer sessions
     * @return returns all accessible multiplayer sessions
     */
    getMultiplayerSessions(includeInvitedPrivateSessions: boolean): Promise<MultiplayerSession[]>;

    /**
     * Get multiplayer session Id by ServerEndpoint
     * @return returns a multiplayer session for a given serverEndpoint
     */
    getMultiplayerSessionByServerEndpoint(serverEndpoint: string): Promise<string>;

    /**
     * Get multiplayer session information
     * @return returns a multiplayer session for a given multiplayerSessionId
     */
    getMultiplayerSession(multiplayerSessionId: string): Promise<MultiplayerSession>;

    /**
     * Initiate joining a Multiplayer Session
     * @return Current user has joined the multiplayer session for a given multiplayerSessionId and can be found in the body of the response.
     */
    joinMultiplayerSession(multiplayerSessionId: string): Promise<JoinMultiplayerSession>;

    /**
     * Initiate leaving a Multiplayer Session
     * @return Leave room success
     */
    leaveMultiplayerSession(multiplayerSessionId: string): Promise<void>;

    /**
     * Initiate leaving a Multiplayer Session & VR Device Session with Telemetry Report
     * @return Leave room success
     */
    leaveMultiplayerAndDeviceSessions(multiplayerSessionId: string): Promise<void>;

    /**
     * Get private multiplayer session information (DEPRECATED) - Use /multiplayer-sessions/{multiplayerSessionId} instead
     * @return returns a multiplayer session for a given multiplayerSessionId
     * @deprecated
     */
    getPrivateMultiplayerSession(multiplayerSessionId: string): Promise<PrivateMultiplayerSession>;

    /**
     * Returns users in a Multiplayer Session
     * @return User Session object with all session properties
     */
    getMultiplayerSessionUsers(multiplayerSessionId: string): Promise<SessionUser[]>;

    /**
     * Invite a user to a multiplayer session
     * @return User is invited
     */
    inviteUserToMultiplayerSession(multiplayerSessionId: string, invitedUserId: string): Promise<void>;

    /**
     * Invite a user to a multiplayer session with Email
     * @return User is invited
     */
    inviteUserToMultiplayerSessionWithEmail(multiplayerSessionId: string, email: string): Promise<void>;

    /**
     * Request access to a private Multiplayer Session from the creator
     * @return Access to a private session is requested.
     */
    requestJoinMultiplayerSession(multiplayerSessionId: string): Promise<void>;

    /**
     * Approve a user's join request
     * @return Approved the join request
     */
    approveJoinRequest(multiplayerSessionId: string, requestorUserId: string): Promise<void>;

    /**
     * Decline a user's join request
     * @return Decline the join request
     */
    declineJoinRequest(multiplayerSessionId: string, requestorUserId: string): Promise<void>;

    /**
     * Accept a multiplayer session invitation
     * @return Accepted the invitation
     */
    acceptInvitation(multiplayerSessionId: string, inviterUserId: string): Promise<void>;

    /**
     * Decline a multiplayer session invitation
     * @return declined the invitation
     */
    declineInvitation(multiplayerSessionId: string, inviterUserId: string): Promise<void>;

    /**
     * Get invitee device sessions in a multiplayer session
     * @return Returns invitee device sessions
     */
    getInviteeDeviceSessions(multiplayerSessionId: string): Promise<DeviceSession[]>;

    /**
     * Validate user access ticket and return user information
     * @return Returns multiplayer session user information.
     */
    requestMultiplayerSessionAccess(multiplayerSessionId: string, accessTicket: string): Promise<MultiplayerSessionUser>;

    /**
     * Get MultiplayerSessionInvitations By MultiplayerSessionId
     * @return Returns MultiplayerSessionInvitation.
     */
    getMultiplayerSessionInvitations(multiplayerSessionId: string): Promise<MultiplayerSessionInvitation[]>;

    /**
     * Get MultiplayerSessionInvitations By MultiplayerSessionId
     * @return Returns pending MultiplayerSessionInvitation sent by user.
     */
    getMultiplayerSessionPendingInvitationsSentByUser(multiplayerSessionId: string): Promise<MultiplayerSessionInvitation[]>;
}

export class SessionManagementClientV1 extends JwtApiBase implements ISessionManagementClientV1 {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Checks if service is alive.
     * @return service is alive.
     */
    ping(): Promise<void> {
        let url_ = this.baseUrl + "/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPing(_response);
        });
    }

    protected processPing(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get content metadata names for a company.
     * @return Returns a list of content metadata names for a company.
     */
    getContentMetadataNames(companyId: string): Promise<ContentMetadataName[]> {
        let url_ = this.baseUrl + "/companies/{companyId}/metrics/content-metadata-names";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContentMetadataNames(_response);
        });
    }

    protected processGetContentMetadataNames(response: Response): Promise<ContentMetadataName[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentMetadataName.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to retrieve this info", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContentMetadataName[]>(<any>null);
    }

    /**
     * Report user-level metrics for a company.
     * @return Returns a list of user-level metric results for the given filters.
     */
    getUserLevelMetrics(companyId: string, body: UserLevelMetricFilter): Promise<UserSessionMetricResult> {
        let url_ = this.baseUrl + "/companies/{companyId}/metrics/user-sessions/user-level";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserLevelMetrics(_response);
        });
    }

    protected processGetUserLevelMetrics(response: Response): Promise<UserSessionMetricResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSessionMetricResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Date range is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to report metrics for this company.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSessionMetricResult>(<any>null);
    }

    /**
     * Report hours in VR metrics for a company.
     * @return Returns a list of metric results for the given filters.
     */
    getHoursInVrMetrics(companyId: string, body: MetricFilter): Promise<MetricResult> {
        let url_ = this.baseUrl + "/companies/{companyId}/metrics/hours-in-vr";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHoursInVrMetrics(_response);
        });
    }

    protected processGetHoursInVrMetrics(response: Response): Promise<MetricResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetricResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Date range is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to report metrics for this company.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MetricResult>(<any>null);
    }

    /**
     * Report unique active user metrics for a company.
     * @return Returns a list of metric results for the given filters.
     */
    getUniqueActiveUserMetrics(companyId: string, body: MetricFilter): Promise<MetricResult> {
        let url_ = this.baseUrl + "/companies/{companyId}/metrics/unique-active-users";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUniqueActiveUserMetrics(_response);
        });
    }

    protected processGetUniqueActiveUserMetrics(response: Response): Promise<MetricResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetricResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Date range is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to report metrics for this company.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MetricResult>(<any>null);
    }

    /**
     * Report all aggregate metrics for a company.
     * @return Returns a list of all aggregate metric results for the given filters.
     */
    getAllAggregateMetrics(companyId: string, body: MetricFilter): Promise<AllAggregateMetricResult> {
        let url_ = this.baseUrl + "/companies/{companyId}/metrics/all-aggregates";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllAggregateMetrics(_response);
        });
    }

    protected processGetAllAggregateMetrics(response: Response): Promise<AllAggregateMetricResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllAggregateMetricResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Date range is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to report metrics for this company.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AllAggregateMetricResult>(<any>null);
    }

    /**
     * Report user session metrics for a company.
     * @return Returns a list of metric results for the given filters.
     */
    getUserSessionMetrics(companyId: string, body: MetricFilter): Promise<MetricResult> {
        let url_ = this.baseUrl + "/companies/{companyId}/metrics/user-sessions";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserSessionMetrics(_response);
        });
    }

    protected processGetUserSessionMetrics(response: Response): Promise<MetricResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetricResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Date range is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to report metrics for this company.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MetricResult>(<any>null);
    }

    /**
     * Report cumulative metrics for a company.
     * @return Returns the cumulative metric results for the given filters.
     */
    getCumulativeMetrics(companyId: string, body: MetricFilter): Promise<CumulativeMetricsResult> {
        let url_ = this.baseUrl + "/companies/{companyId}/metrics/cumulative";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCumulativeMetrics(_response);
        });
    }

    protected processGetCumulativeMetrics(response: Response): Promise<CumulativeMetricsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CumulativeMetricsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Date range is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to report metrics for this company.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CumulativeMetricsResult>(<any>null);
    }

    /**
     * Report Experience-based metrics for a company.
     * @return Returns a list of metric results for the given filters.
     */
    getExperienceDataMetrics(companyId: string, body: MetricFilter): Promise<ExperienceMetricResult> {
        let url_ = this.baseUrl + "/companies/{companyId}/metrics/experience-data";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExperienceDataMetrics(_response);
        });
    }

    protected processGetExperienceDataMetrics(response: Response): Promise<ExperienceMetricResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExperienceMetricResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Date range is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to report metrics for this company.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExperienceMetricResult>(<any>null);
    }

    /**
     * Report Country-based metrics for a company.
     * @return Returns a list of metric results for the given filters.
     */
    getCountryDataMetrics(companyId: string, body: MetricFilter): Promise<CountryMetricResult> {
        let url_ = this.baseUrl + "/companies/{companyId}/metrics/country-data";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCountryDataMetrics(_response);
        });
    }

    protected processGetCountryDataMetrics(response: Response): Promise<CountryMetricResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryMetricResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Date range is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to report metrics for this company.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryMetricResult>(<any>null);
    }

    /**
     * Report hours in VR metrics for a company's licensed experience.
     * @return Returns a list of metric results for the given filters.
     */
    getHoursInVrExternalMetrics(companyId: string, body: ExternalMetricFilter): Promise<MetricResult> {
        let url_ = this.baseUrl + "/companies/{companyId}/external-metrics/hours-in-vr";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHoursInVrExternalMetrics(_response);
        });
    }

    protected processGetHoursInVrExternalMetrics(response: Response): Promise<MetricResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetricResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Date range is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to report metrics for this company.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MetricResult>(<any>null);
    }

    /**
     * Report unique active user metrics for a company's licensed experience.
     * @return Returns a list of metric results for the given filters.
     */
    getUniqueActiveUserExternalMetrics(companyId: string, body: ExternalMetricFilter): Promise<MetricResult> {
        let url_ = this.baseUrl + "/companies/{companyId}/external-metrics/unique-active-users";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUniqueActiveUserExternalMetrics(_response);
        });
    }

    protected processGetUniqueActiveUserExternalMetrics(response: Response): Promise<MetricResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetricResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Date range is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to report metrics for this company.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MetricResult>(<any>null);
    }

    /**
     * Report user session metrics for a company's licensed experience.
     * @return Returns a list of metric results for the given filters.
     */
    getUserSessionExternalMetrics(companyId: string, body: ExternalMetricFilter): Promise<MetricResult> {
        let url_ = this.baseUrl + "/companies/{companyId}/external-metrics/user-sessions";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserSessionExternalMetrics(_response);
        });
    }

    protected processGetUserSessionExternalMetrics(response: Response): Promise<MetricResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MetricResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Date range is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to report metrics for this company.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MetricResult>(<any>null);
    }

    /**
     * Report all aggregate metrics for a company's licensed experience.
     * @return Returns a list of all aggregate metric results for the given filters.
     */
    getAllAggregateExternalMetrics(companyId: string, body: ExternalMetricFilter): Promise<AllAggregateMetricResult> {
        let url_ = this.baseUrl + "/companies/{companyId}/external-metrics/all-aggregates";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllAggregateExternalMetrics(_response);
        });
    }

    protected processGetAllAggregateExternalMetrics(response: Response): Promise<AllAggregateMetricResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllAggregateMetricResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Date range is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to report metrics for this company.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AllAggregateMetricResult>(<any>null);
    }

    /**
     * Report cumulative metrics for a company's licensed experience.
     * @return Returns the cumulative metric results for the given filters.
     */
    getCumulativeExternalMetrics(companyId: string, body: ExternalMetricFilter): Promise<CumulativeMetricsResult> {
        let url_ = this.baseUrl + "/companies/{companyId}/external-metrics/cumulative";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCumulativeExternalMetrics(_response);
        });
    }

    protected processGetCumulativeExternalMetrics(response: Response): Promise<CumulativeMetricsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CumulativeMetricsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Date range is invalid.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to report metrics for this company.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CumulativeMetricsResult>(<any>null);
    }

    /**
     * Get all pending multiplayer session invitations for active sessions for current user.
     * @return returns a list of pending multiplayer session invitations for active sessions for current user
     */
    getCurrentUserPendingMultiplayerSessionInvitations(): Promise<MultiplayerSessionInvitation[]> {
        let url_ = this.baseUrl + "/users/me/multiplayer-session-invitations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUserPendingMultiplayerSessionInvitations(_response);
        });
    }

    protected processGetCurrentUserPendingMultiplayerSessionInvitations(response: Response): Promise<MultiplayerSessionInvitation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MultiplayerSessionInvitation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultiplayerSessionInvitation[]>(<any>null);
    }

    /**
     * Get all multiplayer sessions for current user.
     * @param states (optional) 
     * @return returns a multiplayer session for a given multiplayer session Id
     */
    getCurrentUserMultiplayerSessions(states: UserMultiplayerSessionState[] | undefined): Promise<MultiplayerSession[]> {
        let url_ = this.baseUrl + "/users/me/multiplayer-sessions?";
        if (states === null)
            throw new Error("The parameter 'states' cannot be null.");
        else if (states !== undefined)
            states && states.forEach(item => { url_ += "States=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUserMultiplayerSessions(_response);
        });
    }

    protected processGetCurrentUserMultiplayerSessions(response: Response): Promise<MultiplayerSession[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MultiplayerSession.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultiplayerSession[]>(<any>null);
    }

    /**
     * Create current user device session.
     * @param clientIpAddress (optional) 
     * @return Device Session successfully created and can be found in the body of the response.
     */
    createCurrentUserDeviceSession(clientIpAddress: string | undefined, body: DeviceSessionWithoutId): Promise<DeviceSession> {
        let url_ = this.baseUrl + "/users/me/device-sessions?";
        if (clientIpAddress === null)
            throw new Error("The parameter 'clientIpAddress' cannot be null.");
        else if (clientIpAddress !== undefined)
            url_ += "ClientIpAddress=" + encodeURIComponent("" + clientIpAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCurrentUserDeviceSession(_response);
        });
    }

    protected processCreateCurrentUserDeviceSession(response: Response): Promise<DeviceSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = DeviceSession.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Session should have a body", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceSession>(<any>null);
    }

    /**
     * Returns Current User Device Sessions
     * @return Current User Device Sessions
     */
    getCurrentUserDeviceSessions(): Promise<DeviceSession[]> {
        let url_ = this.baseUrl + "/users/me/device-sessions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUserDeviceSessions(_response);
        });
    }

    protected processGetCurrentUserDeviceSessions(response: Response): Promise<DeviceSession[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceSession.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceSession[]>(<any>null);
    }

    /**
     * Delete the device sessions. If no device session id is provided, all device sessions will be deleted; otherwise, only those specified will be deleted.
     * @param deviceSessionIds (optional) deviceSessionId(s) to be deleted.
     * @param clientIpAddress (optional) 
     * @return Current User Device Sessions have been deleted.
     */
    deleteCurrentUserDeviceSessions(deviceSessionIds: string[] | undefined, clientIpAddress: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/users/me/device-sessions?";
        if (deviceSessionIds === null)
            throw new Error("The parameter 'deviceSessionIds' cannot be null.");
        else if (deviceSessionIds !== undefined)
            deviceSessionIds && deviceSessionIds.forEach(item => { url_ += "deviceSessionIds=" + encodeURIComponent("" + item) + "&"; });
        if (clientIpAddress === null)
            throw new Error("The parameter 'clientIpAddress' cannot be null.");
        else if (clientIpAddress !== undefined)
            url_ += "ClientIpAddress=" + encodeURIComponent("" + clientIpAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCurrentUserDeviceSessions(_response);
        });
    }

    protected processDeleteCurrentUserDeviceSessions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to delete this device session.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Update a Current User Device Session.
     * @param clientIpAddress (optional) 
     * @return Given Current User Device Session has been updated
     */
    updateCurrentUserDeviceSession(deviceSessionId: string, clientIpAddress: string | undefined, body: DeviceSessionToUpdate): Promise<void> {
        let url_ = this.baseUrl + "/users/me/device-sessions/{deviceSessionId}?";
        if (deviceSessionId === undefined || deviceSessionId === null)
            throw new Error("The parameter 'deviceSessionId' must be defined.");
        url_ = url_.replace("{deviceSessionId}", encodeURIComponent("" + deviceSessionId));
        if (clientIpAddress === null)
            throw new Error("The parameter 'clientIpAddress' cannot be null.");
        else if (clientIpAddress !== undefined)
            url_ += "ClientIpAddress=" + encodeURIComponent("" + clientIpAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCurrentUserDeviceSession(_response);
        });
    }

    protected processUpdateCurrentUserDeviceSession(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Device Session should have a body", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to update this device session.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("No Device Session found for given id.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Delete a Current User Device Session
     * @param clientIpAddress (optional) 
     * @return Given Current User Device Session has been deleted.
     */
    deleteCurrentUserDeviceSession(deviceSessionId: string, clientIpAddress: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/users/me/device-sessions/{deviceSessionId}?";
        if (deviceSessionId === undefined || deviceSessionId === null)
            throw new Error("The parameter 'deviceSessionId' must be defined.");
        url_ = url_.replace("{deviceSessionId}", encodeURIComponent("" + deviceSessionId));
        if (clientIpAddress === null)
            throw new Error("The parameter 'clientIpAddress' cannot be null.");
        else if (clientIpAddress !== undefined)
            url_ += "ClientIpAddress=" + encodeURIComponent("" + clientIpAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCurrentUserDeviceSession(_response);
        });
    }

    protected processDeleteCurrentUserDeviceSession(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to delete this Device Session.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Create a new multiplayer session
     * @return Multiplayer session successfully created and can be found in the body of the response.
     */
    createMultiplayerSession(body: MultiplayerSessionWithoutId): Promise<MultiplayerSession> {
        let url_ = this.baseUrl + "/multiplayer-sessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateMultiplayerSession(_response);
        });
    }

    protected processCreateMultiplayerSession(response: Response): Promise<MultiplayerSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = MultiplayerSession.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Max. players should be more than 0 (zero) to create a new session.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A guest user is not allowed to create a company internal session.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Content metadata does not exist.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultiplayerSession>(<any>null);
    }

    /**
     * Get all accessible multiplayer sessions
     * @return returns all accessible multiplayer sessions
     */
    getMultiplayerSessions(includeInvitedPrivateSessions: boolean): Promise<MultiplayerSession[]> {
        let url_ = this.baseUrl + "/multiplayer-sessions?";
        if (includeInvitedPrivateSessions === undefined || includeInvitedPrivateSessions === null)
            throw new Error("The parameter 'includeInvitedPrivateSessions' must be defined and cannot be null.");
        else
            url_ += "includeInvitedPrivateSessions=" + encodeURIComponent("" + includeInvitedPrivateSessions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMultiplayerSessions(_response);
        });
    }

    protected processGetMultiplayerSessions(response: Response): Promise<MultiplayerSession[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MultiplayerSession.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to retrieve this info", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultiplayerSession[]>(<any>null);
    }

    /**
     * Get multiplayer session Id by ServerEndpoint
     * @return returns a multiplayer session for a given serverEndpoint
     */
    getMultiplayerSessionByServerEndpoint(serverEndpoint: string): Promise<string> {
        let url_ = this.baseUrl + "/multiplayer-sessions/multiplayerSessionIdByServerEndpoint?";
        if (serverEndpoint === undefined || serverEndpoint === null)
            throw new Error("The parameter 'serverEndpoint' must be defined and cannot be null.");
        else
            url_ += "serverEndpoint=" + encodeURIComponent("" + serverEndpoint) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMultiplayerSessionByServerEndpoint(_response);
        });
    }

    protected processGetMultiplayerSessionByServerEndpoint(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to retrieve this info", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Multiplayer session does not exist or is inaccessible", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * Get multiplayer session information
     * @return returns a multiplayer session for a given multiplayerSessionId
     */
    getMultiplayerSession(multiplayerSessionId: string): Promise<MultiplayerSession> {
        let url_ = this.baseUrl + "/multiplayer-sessions/{multiplayerSessionId}";
        if (multiplayerSessionId === undefined || multiplayerSessionId === null)
            throw new Error("The parameter 'multiplayerSessionId' must be defined.");
        url_ = url_.replace("{multiplayerSessionId}", encodeURIComponent("" + multiplayerSessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMultiplayerSession(_response);
        });
    }

    protected processGetMultiplayerSession(response: Response): Promise<MultiplayerSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MultiplayerSession.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Multiplayer session does not exist", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultiplayerSession>(<any>null);
    }

    /**
     * Initiate joining a Multiplayer Session
     * @return Current user has joined the multiplayer session for a given multiplayerSessionId and can be found in the body of the response.
     */
    joinMultiplayerSession(multiplayerSessionId: string): Promise<JoinMultiplayerSession> {
        let url_ = this.baseUrl + "/multiplayer-sessions/{multiplayerSessionId}";
        if (multiplayerSessionId === undefined || multiplayerSessionId === null)
            throw new Error("The parameter 'multiplayerSessionId' must be defined.");
        url_ = url_.replace("{multiplayerSessionId}", encodeURIComponent("" + multiplayerSessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processJoinMultiplayerSession(_response);
        });
    }

    protected processJoinMultiplayerSession(response: Response): Promise<JoinMultiplayerSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JoinMultiplayerSession.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Could not join the room", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Multiplayer session does not exist or is inaccessible", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JoinMultiplayerSession>(<any>null);
    }

    /**
     * Initiate leaving a Multiplayer Session
     * @return Leave room success
     */
    leaveMultiplayerSession(multiplayerSessionId: string): Promise<void> {
        let url_ = this.baseUrl + "/multiplayer-sessions/{multiplayerSessionId}";
        if (multiplayerSessionId === undefined || multiplayerSessionId === null)
            throw new Error("The parameter 'multiplayerSessionId' must be defined.");
        url_ = url_.replace("{multiplayerSessionId}", encodeURIComponent("" + multiplayerSessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLeaveMultiplayerSession(_response);
        });
    }

    protected processLeaveMultiplayerSession(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Initiate leaving a Multiplayer Session & VR Device Session with Telemetry Report
     * @return Leave room success
     */
    leaveMultiplayerAndDeviceSessions(multiplayerSessionId: string): Promise<void> {
        let url_ = this.baseUrl + "/multiplayer-sessions/{multiplayerSessionId}/leave";
        if (multiplayerSessionId === undefined || multiplayerSessionId === null)
            throw new Error("The parameter 'multiplayerSessionId' must be defined.");
        url_ = url_.replace("{multiplayerSessionId}", encodeURIComponent("" + multiplayerSessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLeaveMultiplayerAndDeviceSessions(_response);
        });
    }

    protected processLeaveMultiplayerAndDeviceSessions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get private multiplayer session information (DEPRECATED) - Use /multiplayer-sessions/{multiplayerSessionId} instead
     * @return returns a multiplayer session for a given multiplayerSessionId
     * @deprecated
     */
    getPrivateMultiplayerSession(multiplayerSessionId: string): Promise<PrivateMultiplayerSession> {
        let url_ = this.baseUrl + "/multiplayer-sessions/{multiplayerSessionId}/private";
        if (multiplayerSessionId === undefined || multiplayerSessionId === null)
            throw new Error("The parameter 'multiplayerSessionId' must be defined.");
        url_ = url_.replace("{multiplayerSessionId}", encodeURIComponent("" + multiplayerSessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrivateMultiplayerSession(_response);
        });
    }

    protected processGetPrivateMultiplayerSession(response: Response): Promise<PrivateMultiplayerSession> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrivateMultiplayerSession.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to retrieve this info", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Multiplayer session does not exist or is inaccessible", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrivateMultiplayerSession>(<any>null);
    }

    /**
     * Returns users in a Multiplayer Session
     * @return User Session object with all session properties
     */
    getMultiplayerSessionUsers(multiplayerSessionId: string): Promise<SessionUser[]> {
        let url_ = this.baseUrl + "/multiplayer-sessions/{multiplayerSessionId}/users";
        if (multiplayerSessionId === undefined || multiplayerSessionId === null)
            throw new Error("The parameter 'multiplayerSessionId' must be defined.");
        url_ = url_.replace("{multiplayerSessionId}", encodeURIComponent("" + multiplayerSessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMultiplayerSessionUsers(_response);
        });
    }

    protected processGetMultiplayerSessionUsers(response: Response): Promise<SessionUser[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SessionUser.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request. Unable to parse user identifier", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to retrieve this content info", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SessionUser[]>(<any>null);
    }

    /**
     * Invite a user to a multiplayer session
     * @return User is invited
     */
    inviteUserToMultiplayerSession(multiplayerSessionId: string, invitedUserId: string): Promise<void> {
        let url_ = this.baseUrl + "/users/me/multiplayer-sessions/{multiplayerSessionId}/invites/{invitedUserId}";
        if (multiplayerSessionId === undefined || multiplayerSessionId === null)
            throw new Error("The parameter 'multiplayerSessionId' must be defined.");
        url_ = url_.replace("{multiplayerSessionId}", encodeURIComponent("" + multiplayerSessionId));
        if (invitedUserId === undefined || invitedUserId === null)
            throw new Error("The parameter 'invitedUserId' must be defined.");
        url_ = url_.replace("{invitedUserId}", encodeURIComponent("" + invitedUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInviteUserToMultiplayerSession(_response);
        });
    }

    protected processInviteUserToMultiplayerSession(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Invalid request (invitee doesn\'t have permissions to access the session or the payload is invalid)", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("User is not allowed to send this invite", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Multiplayer session does not exist or is inaccessible or user does not exist", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Invite a user to a multiplayer session with Email
     * @return User is invited
     */
    inviteUserToMultiplayerSessionWithEmail(multiplayerSessionId: string, email: string): Promise<void> {
        let url_ = this.baseUrl + "/multiplayer-sessions/{multiplayerSessionId}/email-invitation/{email}";
        if (multiplayerSessionId === undefined || multiplayerSessionId === null)
            throw new Error("The parameter 'multiplayerSessionId' must be defined.");
        url_ = url_.replace("{multiplayerSessionId}", encodeURIComponent("" + multiplayerSessionId));
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInviteUserToMultiplayerSessionWithEmail(_response);
        });
    }

    protected processInviteUserToMultiplayerSessionWithEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Invalid request (invitee doesn\'t have permissions to access the session or the payload is invalid)", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("User is not allowed to send this invite", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Multiplayer session does not exist or is inaccessible or user does not exist", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Request access to a private Multiplayer Session from the creator
     * @return Access to a private session is requested.
     */
    requestJoinMultiplayerSession(multiplayerSessionId: string): Promise<void> {
        let url_ = this.baseUrl + "/multiplayer-sessions/{multiplayerSessionId}/request-join";
        if (multiplayerSessionId === undefined || multiplayerSessionId === null)
            throw new Error("The parameter 'multiplayerSessionId' must be defined.");
        url_ = url_.replace("{multiplayerSessionId}", encodeURIComponent("" + multiplayerSessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRequestJoinMultiplayerSession(_response);
        });
    }

    protected processRequestJoinMultiplayerSession(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("User has insufficient rights to request access to this session or the session is full", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("The session doesn\'t exist", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Approve a user's join request
     * @return Approved the join request
     */
    approveJoinRequest(multiplayerSessionId: string, requestorUserId: string): Promise<void> {
        let url_ = this.baseUrl + "/multiplayer-sessions/{multiplayerSessionId}/approve-join-request/{requestorUserId}";
        if (multiplayerSessionId === undefined || multiplayerSessionId === null)
            throw new Error("The parameter 'multiplayerSessionId' must be defined.");
        url_ = url_.replace("{multiplayerSessionId}", encodeURIComponent("" + multiplayerSessionId));
        if (requestorUserId === undefined || requestorUserId === null)
            throw new Error("The parameter 'requestorUserId' must be defined.");
        url_ = url_.replace("{requestorUserId}", encodeURIComponent("" + requestorUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproveJoinRequest(_response);
        });
    }

    protected processApproveJoinRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to do this action", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("The session or the requestor doesn\'t exist", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Decline a user's join request
     * @return Decline the join request
     */
    declineJoinRequest(multiplayerSessionId: string, requestorUserId: string): Promise<void> {
        let url_ = this.baseUrl + "/multiplayer-sessions/{multiplayerSessionId}/decline-join-request/{requestorUserId}";
        if (multiplayerSessionId === undefined || multiplayerSessionId === null)
            throw new Error("The parameter 'multiplayerSessionId' must be defined.");
        url_ = url_.replace("{multiplayerSessionId}", encodeURIComponent("" + multiplayerSessionId));
        if (requestorUserId === undefined || requestorUserId === null)
            throw new Error("The parameter 'requestorUserId' must be defined.");
        url_ = url_.replace("{requestorUserId}", encodeURIComponent("" + requestorUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeclineJoinRequest(_response);
        });
    }

    protected processDeclineJoinRequest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("You don\'t have permission to do this action", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("The session or the requestor doesn\'t exist", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Accept a multiplayer session invitation
     * @return Accepted the invitation
     */
    acceptInvitation(multiplayerSessionId: string, inviterUserId: string): Promise<void> {
        let url_ = this.baseUrl + "/multiplayer-sessions/{multiplayerSessionId}/accept-invitation/{inviterUserId}";
        if (multiplayerSessionId === undefined || multiplayerSessionId === null)
            throw new Error("The parameter 'multiplayerSessionId' must be defined.");
        url_ = url_.replace("{multiplayerSessionId}", encodeURIComponent("" + multiplayerSessionId));
        if (inviterUserId === undefined || inviterUserId === null)
            throw new Error("The parameter 'inviterUserId' must be defined.");
        url_ = url_.replace("{inviterUserId}", encodeURIComponent("" + inviterUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAcceptInvitation(_response);
        });
    }

    protected processAcceptInvitation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Inviter, invitee or the multiplayer session doesn\'t exist", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Decline a multiplayer session invitation
     * @return declined the invitation
     */
    declineInvitation(multiplayerSessionId: string, inviterUserId: string): Promise<void> {
        let url_ = this.baseUrl + "/multiplayer-sessions/{multiplayerSessionId}/decline-invitation/{inviterUserId}";
        if (multiplayerSessionId === undefined || multiplayerSessionId === null)
            throw new Error("The parameter 'multiplayerSessionId' must be defined.");
        url_ = url_.replace("{multiplayerSessionId}", encodeURIComponent("" + multiplayerSessionId));
        if (inviterUserId === undefined || inviterUserId === null)
            throw new Error("The parameter 'inviterUserId' must be defined.");
        url_ = url_.replace("{inviterUserId}", encodeURIComponent("" + inviterUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeclineInvitation(_response);
        });
    }

    protected processDeclineInvitation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Inviter, invitee or the multiplayer session doesn\'t exist", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get invitee device sessions in a multiplayer session
     * @return Returns invitee device sessions
     */
    getInviteeDeviceSessions(multiplayerSessionId: string): Promise<DeviceSession[]> {
        let url_ = this.baseUrl + "/multiplayer-sessions/{multiplayerSessionId}/device-sessions";
        if (multiplayerSessionId === undefined || multiplayerSessionId === null)
            throw new Error("The parameter 'multiplayerSessionId' must be defined.");
        url_ = url_.replace("{multiplayerSessionId}", encodeURIComponent("" + multiplayerSessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInviteeDeviceSessions(_response);
        });
    }

    protected processGetInviteeDeviceSessions(response: Response): Promise<DeviceSession[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceSession.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("The multiplayer session doesn\'t exist.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceSession[]>(<any>null);
    }

    /**
     * Validate user access ticket and return user information
     * @return Returns multiplayer session user information.
     */
    requestMultiplayerSessionAccess(multiplayerSessionId: string, accessTicket: string): Promise<MultiplayerSessionUser> {
        let url_ = this.baseUrl + "/multiplayer-sessions/{multiplayerSessionId}/access/{accessTicket}";
        if (multiplayerSessionId === undefined || multiplayerSessionId === null)
            throw new Error("The parameter 'multiplayerSessionId' must be defined.");
        url_ = url_.replace("{multiplayerSessionId}", encodeURIComponent("" + multiplayerSessionId));
        if (accessTicket === undefined || accessTicket === null)
            throw new Error("The parameter 'accessTicket' must be defined.");
        url_ = url_.replace("{accessTicket}", encodeURIComponent("" + accessTicket));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRequestMultiplayerSessionAccess(_response);
        });
    }

    protected processRequestMultiplayerSessionAccess(response: Response): Promise<MultiplayerSessionUser> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MultiplayerSessionUser.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Could not find session", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("The session doesn\'t exist.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultiplayerSessionUser>(<any>null);
    }

    /**
     * Get MultiplayerSessionInvitations By MultiplayerSessionId
     * @return Returns MultiplayerSessionInvitation.
     */
    getMultiplayerSessionInvitations(multiplayerSessionId: string): Promise<MultiplayerSessionInvitation[]> {
        let url_ = this.baseUrl + "/multiplayer-sessions/{multiplayerSessionId}/multiplayer-session-invitations";
        if (multiplayerSessionId === undefined || multiplayerSessionId === null)
            throw new Error("The parameter 'multiplayerSessionId' must be defined.");
        url_ = url_.replace("{multiplayerSessionId}", encodeURIComponent("" + multiplayerSessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMultiplayerSessionInvitations(_response);
        });
    }

    protected processGetMultiplayerSessionInvitations(response: Response): Promise<MultiplayerSessionInvitation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MultiplayerSessionInvitation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Could not find session", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("The session doesn\'t exist.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultiplayerSessionInvitation[]>(<any>null);
    }

    /**
     * Get MultiplayerSessionInvitations By MultiplayerSessionId
     * @return Returns pending MultiplayerSessionInvitation sent by user.
     */
    getMultiplayerSessionPendingInvitationsSentByUser(multiplayerSessionId: string): Promise<MultiplayerSessionInvitation[]> {
        let url_ = this.baseUrl + "/multiplayer-sessions/{multiplayerSessionId}/pending-multiplayer-session-invitations";
        if (multiplayerSessionId === undefined || multiplayerSessionId === null)
            throw new Error("The parameter 'multiplayerSessionId' must be defined.");
        url_ = url_.replace("{multiplayerSessionId}", encodeURIComponent("" + multiplayerSessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMultiplayerSessionPendingInvitationsSentByUser(_response);
        });
    }

    protected processGetMultiplayerSessionPendingInvitationsSentByUser(response: Response): Promise<MultiplayerSessionInvitation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MultiplayerSessionInvitation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Don\'t have access to session.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("The session doesn\'t exist.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultiplayerSessionInvitation[]>(<any>null);
    }
}

export class ContentMetadataName implements IContentMetadataName {
    contentMetadataId!: string;
    friendlyName!: string;

    constructor(data?: IContentMetadataName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentMetadataId = _data["ContentMetadataId"];
            this.friendlyName = _data["FriendlyName"];
        }
    }

    static fromJS(data: any): ContentMetadataName {
        data = typeof data === 'object' ? data : {};
        let result = new ContentMetadataName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContentMetadataId"] = this.contentMetadataId;
        data["FriendlyName"] = this.friendlyName;
        return data;
    }
}

export interface IContentMetadataName {
    contentMetadataId: string;
    friendlyName: string;
}

export class DeviceSessionWithoutId implements IDeviceSessionWithoutId {
    applicationType!: ApplicationType;
    multiplayerSessionId?: string;

    constructor(data?: IDeviceSessionWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationType = _data["ApplicationType"];
            this.multiplayerSessionId = _data["MultiplayerSessionId"];
        }
    }

    static fromJS(data: any): DeviceSessionWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceSessionWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ApplicationType"] = this.applicationType;
        data["MultiplayerSessionId"] = this.multiplayerSessionId;
        return data;
    }
}

export interface IDeviceSessionWithoutId {
    applicationType: ApplicationType;
    multiplayerSessionId?: string;
}

export class DeviceSessionToUpdate implements IDeviceSessionToUpdate {
    multiplayerSessionId?: string;

    constructor(data?: IDeviceSessionToUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.multiplayerSessionId = _data["MultiplayerSessionId"];
        }
    }

    static fromJS(data: any): DeviceSessionToUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceSessionToUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MultiplayerSessionId"] = this.multiplayerSessionId;
        return data;
    }
}

export interface IDeviceSessionToUpdate {
    multiplayerSessionId?: string;
}

export class SessionUser implements ISessionUser {
    userId!: string;
    state!: UserMultiplayerSessionState;
    userAvailabilityStatus!: UserAvailabilityStatus;
    deviceSessions?: DeviceSession[];

    constructor(data?: ISessionUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.state = _data["State"];
            this.userAvailabilityStatus = _data["UserAvailabilityStatus"];
            if (Array.isArray(_data["DeviceSessions"])) {
                this.deviceSessions = [] as any;
                for (let item of _data["DeviceSessions"])
                    this.deviceSessions!.push(DeviceSession.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SessionUser {
        data = typeof data === 'object' ? data : {};
        let result = new SessionUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["State"] = this.state;
        data["UserAvailabilityStatus"] = this.userAvailabilityStatus;
        if (Array.isArray(this.deviceSessions)) {
            data["DeviceSessions"] = [];
            for (let item of this.deviceSessions)
                data["DeviceSessions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISessionUser {
    userId: string;
    state: UserMultiplayerSessionState;
    userAvailabilityStatus: UserAvailabilityStatus;
    deviceSessions?: DeviceSession[];
}

export class DeviceSession implements IDeviceSession {
    multiplayerSessionId?: string;
    deviceSessionId!: string;
    applicationType!: ApplicationType;
    timestamp!: Date;
    userId!: string;
    wentOnlineTime!: Date;

    constructor(data?: IDeviceSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.multiplayerSessionId = _data["MultiplayerSessionId"];
            this.deviceSessionId = _data["DeviceSessionId"];
            this.applicationType = _data["ApplicationType"];
            this.timestamp = _data["Timestamp"] ? new Date(_data["Timestamp"].toString()) : <any>undefined;
            this.userId = _data["UserId"];
            this.wentOnlineTime = _data["WentOnlineTime"] ? new Date(_data["WentOnlineTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceSession {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MultiplayerSessionId"] = this.multiplayerSessionId;
        data["DeviceSessionId"] = this.deviceSessionId;
        data["ApplicationType"] = this.applicationType;
        data["Timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["UserId"] = this.userId;
        data["WentOnlineTime"] = this.wentOnlineTime ? this.wentOnlineTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDeviceSession {
    multiplayerSessionId?: string;
    deviceSessionId: string;
    applicationType: ApplicationType;
    timestamp: Date;
    userId: string;
    wentOnlineTime: Date;
}

export class MultiplayerSessionWithoutId implements IMultiplayerSessionWithoutId {
    /** Title will be empty if you do not get permission to access the multiplayer session */
    title!: string;
    roomMetadataId!: string;
    visibility!: VisibilityType;
    replayId?: string;
    contentVersion?: string;

    constructor(data?: IMultiplayerSessionWithoutId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"];
            this.roomMetadataId = _data["RoomMetadataId"];
            this.visibility = _data["Visibility"];
            this.replayId = _data["ReplayId"];
            this.contentVersion = _data["ContentVersion"];
        }
    }

    static fromJS(data: any): MultiplayerSessionWithoutId {
        data = typeof data === 'object' ? data : {};
        let result = new MultiplayerSessionWithoutId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title;
        data["RoomMetadataId"] = this.roomMetadataId;
        data["Visibility"] = this.visibility;
        data["ReplayId"] = this.replayId;
        data["ContentVersion"] = this.contentVersion;
        return data;
    }
}

export interface IMultiplayerSessionWithoutId {
    /** Title will be empty if you do not get permission to access the multiplayer session */
    title: string;
    roomMetadataId: string;
    visibility: VisibilityType;
    replayId?: string;
    contentVersion?: string;
}

export class MultiplayerSessionInvitation implements IMultiplayerSessionInvitation {
    multiplayerSessionId!: string;
    inviterUserId?: string;
    inviteeUserId!: string;
    invitationStatus!: InvitationStatus;

    constructor(data?: IMultiplayerSessionInvitation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.multiplayerSessionId = _data["MultiplayerSessionId"];
            this.inviterUserId = _data["InviterUserId"];
            this.inviteeUserId = _data["InviteeUserId"];
            this.invitationStatus = _data["InvitationStatus"];
        }
    }

    static fromJS(data: any): MultiplayerSessionInvitation {
        data = typeof data === 'object' ? data : {};
        let result = new MultiplayerSessionInvitation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MultiplayerSessionId"] = this.multiplayerSessionId;
        data["InviterUserId"] = this.inviterUserId;
        data["InviteeUserId"] = this.inviteeUserId;
        data["InvitationStatus"] = this.invitationStatus;
        return data;
    }
}

export interface IMultiplayerSessionInvitation {
    multiplayerSessionId: string;
    inviterUserId?: string;
    inviteeUserId: string;
    invitationStatus: InvitationStatus;
}

export class MultiplayerSession extends MultiplayerSessionWithoutId implements IMultiplayerSession {
    multiplayerSessionId!: string;
    creationDate!: Date;
    visibility!: VisibilityType;
    isRecordingReplay!: boolean;
    currentPlayers!: number;
    /** Server Endpoint will be empty if you do not get permission to access the multiplayer session */
    serverEndpoint?: string;
    creatorUserId!: string;
    roomMetadataId?: string;
    contentVersion!: string;
    region!: string;
    maxPlayers?: number;

    constructor(data?: IMultiplayerSession) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.multiplayerSessionId = _data["MultiplayerSessionId"];
            this.creationDate = _data["CreationDate"] ? new Date(_data["CreationDate"].toString()) : <any>undefined;
            this.visibility = _data["Visibility"];
            this.isRecordingReplay = _data["IsRecordingReplay"];
            this.currentPlayers = _data["CurrentPlayers"];
            this.serverEndpoint = _data["ServerEndpoint"];
            this.creatorUserId = _data["CreatorUserId"];
            this.roomMetadataId = _data["RoomMetadataId"];
            this.contentVersion = _data["ContentVersion"];
            this.region = _data["Region"];
            this.maxPlayers = _data["MaxPlayers"];
        }
    }

    static fromJS(data: any): MultiplayerSession {
        data = typeof data === 'object' ? data : {};
        let result = new MultiplayerSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MultiplayerSessionId"] = this.multiplayerSessionId;
        data["CreationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["Visibility"] = this.visibility;
        data["IsRecordingReplay"] = this.isRecordingReplay;
        data["CurrentPlayers"] = this.currentPlayers;
        data["ServerEndpoint"] = this.serverEndpoint;
        data["CreatorUserId"] = this.creatorUserId;
        data["RoomMetadataId"] = this.roomMetadataId;
        data["ContentVersion"] = this.contentVersion;
        data["Region"] = this.region;
        data["MaxPlayers"] = this.maxPlayers;
        super.toJSON(data);
        return data;
    }
}

export interface IMultiplayerSession extends IMultiplayerSessionWithoutId {
    multiplayerSessionId: string;
    creationDate: Date;
    visibility: VisibilityType;
    isRecordingReplay: boolean;
    currentPlayers: number;
    /** Server Endpoint will be empty if you do not get permission to access the multiplayer session */
    serverEndpoint?: string;
    creatorUserId: string;
    roomMetadataId?: string;
    contentVersion: string;
    region: string;
    maxPlayers?: number;
}

export class PrivateMultiplayerSession implements IPrivateMultiplayerSession {
    multiplayerSessionId!: string;
    roomMetaDataId!: string;

    constructor(data?: IPrivateMultiplayerSession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.multiplayerSessionId = _data["MultiplayerSessionId"];
            this.roomMetaDataId = _data["RoomMetaDataId"];
        }
    }

    static fromJS(data: any): PrivateMultiplayerSession {
        data = typeof data === 'object' ? data : {};
        let result = new PrivateMultiplayerSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MultiplayerSessionId"] = this.multiplayerSessionId;
        data["RoomMetaDataId"] = this.roomMetaDataId;
        return data;
    }
}

export interface IPrivateMultiplayerSession {
    multiplayerSessionId: string;
    roomMetaDataId: string;
}

export class JoinMultiplayerSession extends MultiplayerSession implements IJoinMultiplayerSession {
    serverEndpoint?: string;
    accessTicket?: string;

    constructor(data?: IJoinMultiplayerSession) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.serverEndpoint = _data["ServerEndpoint"];
            this.accessTicket = _data["AccessTicket"];
        }
    }

    static fromJS(data: any): JoinMultiplayerSession {
        data = typeof data === 'object' ? data : {};
        let result = new JoinMultiplayerSession();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ServerEndpoint"] = this.serverEndpoint;
        data["AccessTicket"] = this.accessTicket;
        super.toJSON(data);
        return data;
    }
}

export interface IJoinMultiplayerSession extends IMultiplayerSession {
    serverEndpoint?: string;
    accessTicket?: string;
}

export class MultiplayerSessionUser implements IMultiplayerSessionUser {
    userId!: string;
    companyId!: string;
    userName!: string;
    accessTicket!: string;

    constructor(data?: IMultiplayerSessionUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["UserId"];
            this.companyId = _data["CompanyId"];
            this.userName = _data["UserName"];
            this.accessTicket = _data["AccessTicket"];
        }
    }

    static fromJS(data: any): MultiplayerSessionUser {
        data = typeof data === 'object' ? data : {};
        let result = new MultiplayerSessionUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["UserId"] = this.userId;
        data["CompanyId"] = this.companyId;
        data["UserName"] = this.userName;
        data["AccessTicket"] = this.accessTicket;
        return data;
    }
}

export interface IMultiplayerSessionUser {
    userId: string;
    companyId: string;
    userName: string;
    accessTicket: string;
}

export class DateFilter implements IDateFilter {
    startDate!: Date;
    endDate!: Date;

    constructor(data?: IDateFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["StartDate"] ? new Date(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? new Date(_data["EndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateFilter {
        data = typeof data === 'object' ? data : {};
        let result = new DateFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDateFilter {
    startDate: Date;
    endDate: Date;
}

export class UserLevelMetricFilter extends DateFilter implements IUserLevelMetricFilter {
    minSessionDurationInSeconds?: number;

    constructor(data?: IUserLevelMetricFilter) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minSessionDurationInSeconds = _data["MinSessionDurationInSeconds"];
        }
    }

    static fromJS(data: any): UserLevelMetricFilter {
        data = typeof data === 'object' ? data : {};
        let result = new UserLevelMetricFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["MinSessionDurationInSeconds"] = this.minSessionDurationInSeconds;
        super.toJSON(data);
        return data;
    }
}

export interface IUserLevelMetricFilter extends IDateFilter {
    minSessionDurationInSeconds?: number;
}

export class MetricFilter implements IMetricFilter {
    startDate!: Date;
    endDate!: Date;
    dimension!: Dimension;
    contentMetadataIds?: string[];
    countries?: string[];
    minSessionDurationInSeconds?: number;

    constructor(data?: IMetricFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["StartDate"] ? new Date(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? new Date(_data["EndDate"].toString()) : <any>undefined;
            this.dimension = _data["Dimension"];
            if (Array.isArray(_data["ContentMetadataIds"])) {
                this.contentMetadataIds = [] as any;
                for (let item of _data["ContentMetadataIds"])
                    this.contentMetadataIds!.push(item);
            }
            if (Array.isArray(_data["Countries"])) {
                this.countries = [] as any;
                for (let item of _data["Countries"])
                    this.countries!.push(item);
            }
            this.minSessionDurationInSeconds = _data["MinSessionDurationInSeconds"];
        }
    }

    static fromJS(data: any): MetricFilter {
        data = typeof data === 'object' ? data : {};
        let result = new MetricFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["Dimension"] = this.dimension;
        if (Array.isArray(this.contentMetadataIds)) {
            data["ContentMetadataIds"] = [];
            for (let item of this.contentMetadataIds)
                data["ContentMetadataIds"].push(item);
        }
        if (Array.isArray(this.countries)) {
            data["Countries"] = [];
            for (let item of this.countries)
                data["Countries"].push(item);
        }
        data["MinSessionDurationInSeconds"] = this.minSessionDurationInSeconds;
        return data;
    }
}

export interface IMetricFilter {
    startDate: Date;
    endDate: Date;
    dimension: Dimension;
    contentMetadataIds?: string[];
    countries?: string[];
    minSessionDurationInSeconds?: number;
}

export class ExternalMetricFilter implements IExternalMetricFilter {
    startDate!: Date;
    endDate!: Date;
    dimension!: Dimension;
    licenseIds!: string[];
    minSessionDurationInSeconds?: number;

    constructor(data?: IExternalMetricFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.licenseIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["StartDate"] ? new Date(_data["StartDate"].toString()) : <any>undefined;
            this.endDate = _data["EndDate"] ? new Date(_data["EndDate"].toString()) : <any>undefined;
            this.dimension = _data["Dimension"];
            if (Array.isArray(_data["LicenseIds"])) {
                this.licenseIds = [] as any;
                for (let item of _data["LicenseIds"])
                    this.licenseIds!.push(item);
            }
            this.minSessionDurationInSeconds = _data["MinSessionDurationInSeconds"];
        }
    }

    static fromJS(data: any): ExternalMetricFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalMetricFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["Dimension"] = this.dimension;
        if (Array.isArray(this.licenseIds)) {
            data["LicenseIds"] = [];
            for (let item of this.licenseIds)
                data["LicenseIds"].push(item);
        }
        data["MinSessionDurationInSeconds"] = this.minSessionDurationInSeconds;
        return data;
    }
}

export interface IExternalMetricFilter {
    startDate: Date;
    endDate: Date;
    dimension: Dimension;
    licenseIds: string[];
    minSessionDurationInSeconds?: number;
}

export class MetricResult implements IMetricResult {
    dataPoints!: DataPoint[];
    aggregateValue!: number;

    constructor(data?: IMetricResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dataPoints = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["DataPoints"])) {
                this.dataPoints = [] as any;
                for (let item of _data["DataPoints"])
                    this.dataPoints!.push(DataPoint.fromJS(item));
            }
            this.aggregateValue = _data["AggregateValue"];
        }
    }

    static fromJS(data: any): MetricResult {
        data = typeof data === 'object' ? data : {};
        let result = new MetricResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataPoints)) {
            data["DataPoints"] = [];
            for (let item of this.dataPoints)
                data["DataPoints"].push(item.toJSON());
        }
        data["AggregateValue"] = this.aggregateValue;
        return data;
    }
}

export interface IMetricResult {
    dataPoints: DataPoint[];
    aggregateValue: number;
}

export class CumulativeMetricsResult implements ICumulativeMetricsResult {
    hoursInVr!: MetricResult;
    uniqueUsers!: MetricResult;
    userSessions!: MetricResult;

    constructor(data?: ICumulativeMetricsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.hoursInVr = new MetricResult();
            this.uniqueUsers = new MetricResult();
            this.userSessions = new MetricResult();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hoursInVr = _data["HoursInVr"] ? MetricResult.fromJS(_data["HoursInVr"]) : new MetricResult();
            this.uniqueUsers = _data["UniqueUsers"] ? MetricResult.fromJS(_data["UniqueUsers"]) : new MetricResult();
            this.userSessions = _data["UserSessions"] ? MetricResult.fromJS(_data["UserSessions"]) : new MetricResult();
        }
    }

    static fromJS(data: any): CumulativeMetricsResult {
        data = typeof data === 'object' ? data : {};
        let result = new CumulativeMetricsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["HoursInVr"] = this.hoursInVr ? this.hoursInVr.toJSON() : <any>undefined;
        data["UniqueUsers"] = this.uniqueUsers ? this.uniqueUsers.toJSON() : <any>undefined;
        data["UserSessions"] = this.userSessions ? this.userSessions.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICumulativeMetricsResult {
    hoursInVr: MetricResult;
    uniqueUsers: MetricResult;
    userSessions: MetricResult;
}

export class AllAggregateMetricResult implements IAllAggregateMetricResult {
    aggregateUniqueUsersValue!: number;
    aggregateHoursInVrValue!: number;
    aggregateUserSessionsValue!: number;
    aggregateCertificationsValue!: number;
    dataPoints?: AllMetricsDataPoint[];

    constructor(data?: IAllAggregateMetricResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aggregateUniqueUsersValue = _data["AggregateUniqueUsersValue"];
            this.aggregateHoursInVrValue = _data["AggregateHoursInVrValue"];
            this.aggregateUserSessionsValue = _data["AggregateUserSessionsValue"];
            this.aggregateCertificationsValue = _data["AggregateCertificationsValue"];
            if (Array.isArray(_data["DataPoints"])) {
                this.dataPoints = [] as any;
                for (let item of _data["DataPoints"])
                    this.dataPoints!.push(AllMetricsDataPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllAggregateMetricResult {
        data = typeof data === 'object' ? data : {};
        let result = new AllAggregateMetricResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AggregateUniqueUsersValue"] = this.aggregateUniqueUsersValue;
        data["AggregateHoursInVrValue"] = this.aggregateHoursInVrValue;
        data["AggregateUserSessionsValue"] = this.aggregateUserSessionsValue;
        data["AggregateCertificationsValue"] = this.aggregateCertificationsValue;
        if (Array.isArray(this.dataPoints)) {
            data["DataPoints"] = [];
            for (let item of this.dataPoints)
                data["DataPoints"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAllAggregateMetricResult {
    aggregateUniqueUsersValue: number;
    aggregateHoursInVrValue: number;
    aggregateUserSessionsValue: number;
    aggregateCertificationsValue: number;
    dataPoints?: AllMetricsDataPoint[];
}

export class UserSessionMetricResult implements IUserSessionMetricResult {
    userSessionDataPoints!: UserSessionDataPoint[];

    constructor(data?: IUserSessionMetricResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userSessionDataPoints = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["UserSessionDataPoints"])) {
                this.userSessionDataPoints = [] as any;
                for (let item of _data["UserSessionDataPoints"])
                    this.userSessionDataPoints!.push(UserSessionDataPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserSessionMetricResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserSessionMetricResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userSessionDataPoints)) {
            data["UserSessionDataPoints"] = [];
            for (let item of this.userSessionDataPoints)
                data["UserSessionDataPoints"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserSessionMetricResult {
    userSessionDataPoints: UserSessionDataPoint[];
}

export class UserSessionDataPoint implements IUserSessionDataPoint {
    experienceName!: string;
    contentMetadataId!: string;
    sessionDurationInSeconds!: number;
    userId!: string;
    sessionStartTime!: Date;
    multiplayerSessionId!: string;
    country?: string;

    constructor(data?: IUserSessionDataPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experienceName = _data["ExperienceName"];
            this.contentMetadataId = _data["ContentMetadataId"];
            this.sessionDurationInSeconds = _data["SessionDurationInSeconds"];
            this.userId = _data["UserId"];
            this.sessionStartTime = _data["SessionStartTime"] ? new Date(_data["SessionStartTime"].toString()) : <any>undefined;
            this.multiplayerSessionId = _data["MultiplayerSessionId"];
            this.country = _data["Country"];
        }
    }

    static fromJS(data: any): UserSessionDataPoint {
        data = typeof data === 'object' ? data : {};
        let result = new UserSessionDataPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ExperienceName"] = this.experienceName;
        data["ContentMetadataId"] = this.contentMetadataId;
        data["SessionDurationInSeconds"] = this.sessionDurationInSeconds;
        data["UserId"] = this.userId;
        data["SessionStartTime"] = this.sessionStartTime ? this.sessionStartTime.toISOString() : <any>undefined;
        data["MultiplayerSessionId"] = this.multiplayerSessionId;
        data["Country"] = this.country;
        return data;
    }
}

export interface IUserSessionDataPoint {
    experienceName: string;
    contentMetadataId: string;
    sessionDurationInSeconds: number;
    userId: string;
    sessionStartTime: Date;
    multiplayerSessionId: string;
    country?: string;
}

export class ExperienceMetricResult implements IExperienceMetricResult {
    experienceDataPoints!: ExperienceDataPoint[];

    constructor(data?: IExperienceMetricResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.experienceDataPoints = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ExperienceDataPoints"])) {
                this.experienceDataPoints = [] as any;
                for (let item of _data["ExperienceDataPoints"])
                    this.experienceDataPoints!.push(ExperienceDataPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExperienceMetricResult {
        data = typeof data === 'object' ? data : {};
        let result = new ExperienceMetricResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.experienceDataPoints)) {
            data["ExperienceDataPoints"] = [];
            for (let item of this.experienceDataPoints)
                data["ExperienceDataPoints"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExperienceMetricResult {
    experienceDataPoints: ExperienceDataPoint[];
}

export class CountryMetricResult implements ICountryMetricResult {
    countryDataPoints!: CountryDataPoint[];

    constructor(data?: ICountryMetricResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.countryDataPoints = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["CountryDataPoints"])) {
                this.countryDataPoints = [] as any;
                for (let item of _data["CountryDataPoints"])
                    this.countryDataPoints!.push(CountryDataPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryMetricResult {
        data = typeof data === 'object' ? data : {};
        let result = new CountryMetricResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countryDataPoints)) {
            data["CountryDataPoints"] = [];
            for (let item of this.countryDataPoints)
                data["CountryDataPoints"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICountryMetricResult {
    countryDataPoints: CountryDataPoint[];
}

export class CountryDataPoint implements ICountryDataPoint {
    country!: string;
    uniqueUsers!: number;
    hoursInVr!: number;
    userSessions!: number;
    certifications!: number;

    constructor(data?: ICountryDataPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["Country"];
            this.uniqueUsers = _data["UniqueUsers"];
            this.hoursInVr = _data["HoursInVr"];
            this.userSessions = _data["UserSessions"];
            this.certifications = _data["Certifications"];
        }
    }

    static fromJS(data: any): CountryDataPoint {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDataPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Country"] = this.country;
        data["UniqueUsers"] = this.uniqueUsers;
        data["HoursInVr"] = this.hoursInVr;
        data["UserSessions"] = this.userSessions;
        data["Certifications"] = this.certifications;
        return data;
    }
}

export interface ICountryDataPoint {
    country: string;
    uniqueUsers: number;
    hoursInVr: number;
    userSessions: number;
    certifications: number;
}

export class ExperienceDataPoint implements IExperienceDataPoint {
    contentMetadataFriendlyName!: string;
    contentMetadataId!: string;
    uniqueUsers!: number;
    hoursInVr!: number;
    userSessions!: number;
    certifications!: number;

    constructor(data?: IExperienceDataPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentMetadataFriendlyName = _data["ContentMetadataFriendlyName"];
            this.contentMetadataId = _data["ContentMetadataId"];
            this.uniqueUsers = _data["UniqueUsers"];
            this.hoursInVr = _data["HoursInVr"];
            this.userSessions = _data["UserSessions"];
            this.certifications = _data["Certifications"];
        }
    }

    static fromJS(data: any): ExperienceDataPoint {
        data = typeof data === 'object' ? data : {};
        let result = new ExperienceDataPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ContentMetadataFriendlyName"] = this.contentMetadataFriendlyName;
        data["ContentMetadataId"] = this.contentMetadataId;
        data["UniqueUsers"] = this.uniqueUsers;
        data["HoursInVr"] = this.hoursInVr;
        data["UserSessions"] = this.userSessions;
        data["Certifications"] = this.certifications;
        return data;
    }
}

export interface IExperienceDataPoint {
    contentMetadataFriendlyName: string;
    contentMetadataId: string;
    uniqueUsers: number;
    hoursInVr: number;
    userSessions: number;
    certifications: number;
}

export class AllMetricsDataPoint implements IAllMetricsDataPoint {
    hoursInVrValue!: number;
    uniqueUsersValue!: number;
    userSessionsValue!: number;
    certificationsValue!: number;
    year?: number;
    dimensionIndex!: number;
    dimensionStartDate!: Date;
    dimensionEndDate!: Date;

    constructor(data?: IAllMetricsDataPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hoursInVrValue = _data["HoursInVrValue"];
            this.uniqueUsersValue = _data["UniqueUsersValue"];
            this.userSessionsValue = _data["UserSessionsValue"];
            this.certificationsValue = _data["CertificationsValue"];
            this.year = _data["Year"];
            this.dimensionIndex = _data["DimensionIndex"];
            this.dimensionStartDate = _data["DimensionStartDate"] ? new Date(_data["DimensionStartDate"].toString()) : <any>undefined;
            this.dimensionEndDate = _data["DimensionEndDate"] ? new Date(_data["DimensionEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AllMetricsDataPoint {
        data = typeof data === 'object' ? data : {};
        let result = new AllMetricsDataPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["HoursInVrValue"] = this.hoursInVrValue;
        data["UniqueUsersValue"] = this.uniqueUsersValue;
        data["UserSessionsValue"] = this.userSessionsValue;
        data["CertificationsValue"] = this.certificationsValue;
        data["Year"] = this.year;
        data["DimensionIndex"] = this.dimensionIndex;
        data["DimensionStartDate"] = this.dimensionStartDate ? this.dimensionStartDate.toISOString() : <any>undefined;
        data["DimensionEndDate"] = this.dimensionEndDate ? this.dimensionEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAllMetricsDataPoint {
    hoursInVrValue: number;
    uniqueUsersValue: number;
    userSessionsValue: number;
    certificationsValue: number;
    year?: number;
    dimensionIndex: number;
    dimensionStartDate: Date;
    dimensionEndDate: Date;
}

export class DataPoint implements IDataPoint {
    value!: number;
    year?: number;
    dimensionIndex!: number;
    dimensionStartDate!: Date;
    dimensionEndDate!: Date;

    constructor(data?: IDataPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["Value"];
            this.year = _data["Year"];
            this.dimensionIndex = _data["DimensionIndex"];
            this.dimensionStartDate = _data["DimensionStartDate"] ? new Date(_data["DimensionStartDate"].toString()) : <any>undefined;
            this.dimensionEndDate = _data["DimensionEndDate"] ? new Date(_data["DimensionEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DataPoint {
        data = typeof data === 'object' ? data : {};
        let result = new DataPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Value"] = this.value;
        data["Year"] = this.year;
        data["DimensionIndex"] = this.dimensionIndex;
        data["DimensionStartDate"] = this.dimensionStartDate ? this.dimensionStartDate.toISOString() : <any>undefined;
        data["DimensionEndDate"] = this.dimensionEndDate ? this.dimensionEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDataPoint {
    value: number;
    year?: number;
    dimensionIndex: number;
    dimensionStartDate: Date;
    dimensionEndDate: Date;
}

export enum UserAvailabilityStatus {
    Offline = "Offline",
    Online = "Online",
    Away = "Away",
    Busy = "Busy",
}

export enum VisibilityType {
    Public = "Public",
    Internal = "Internal",
    Private = "Private",
}

export enum ApplicationType {
    DesktopApp = "DesktopApp",
    VR = "VR",
    AR = "AR",
}

export enum UserOnlineStatus {
    Normal = "Normal",
    Busy = "Busy",
    Away = "Away",
}

export enum UserMultiplayerSessionState {
    Joining = "Joining",
    InSession = "InSession",
    Leaving = "Leaving",
}

export enum InvitationStatus {
    Pending = "Pending",
    Accepted = "Accepted",
    Declined = "Declined",
}

export enum Dimension {
    Week = "Week",
    Month = "Month",
    Quarter = "Quarter",
    Year = "Year",
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/* tslint:disable */
/* eslint-disable */